import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { SectionCard } from './SectionCard';

interface EmptyStateMessageProps {
  message: string;
  icon?: ReactNode;
  variant?: 'inline' | 'card';
}

export function EmptyStateMessage({
  message,
  icon,
  variant = 'inline',
}: EmptyStateMessageProps) {
  const body = (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        py: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        justifyContent: 'center',
      }}
    >
      {icon}
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );

  if (variant === 'card') {
    return <SectionCard>{body}</SectionCard>;
  }

  return body;
}

export default EmptyStateMessage;
